import { render } from "./edge2Page.vue?vue&type=template&id=f46f4d16"
import script from "./edge2Page.vue?vue&type=script&lang=js"
export * from "./edge2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__